import React from "react";
import { useLang } from "@/context/LanguageContext";
import SEO from "@/components/SEO";

const CONTENT = {
    it: {
        title: "Privacy Policy",
        eyebrow: "Informativa Privacy",
        updated: "Ultimo aggiornamento: Aprile 2026",
        sections: [
            {
                h: "1. Titolare del trattamento",
                p: "Il titolare del trattamento dei dati raccolti tramite il sito abnormalworld.it è ABNORMAL WORLD — Monte Argentario (GR), Toscana, Italia. Contatto: info@abnormalworld.it",
            },
            {
                h: "2. Dati raccolti",
                p: "Raccogliamo solo i dati strettamente necessari al funzionamento del sito: (a) dati di registrazione volontaria (nome, email, password cifrata) per gli utenti che si iscrivono alla community; (b) foto e contenuti caricati volontariamente dagli utenti; (c) dati tecnici di navigazione (indirizzo IP anonimizzato, tipo browser, pagine visitate) raccolti tramite cookie tecnici e, con il tuo consenso, cookie di analytics.",
            },
            {
                h: "3. Finalità",
                p: "Utilizziamo i dati per: permettere l'accesso all'area registrata, pubblicare i contenuti che carichi, migliorare il funzionamento del sito e — con il tuo consenso — analizzare in forma anonima le statistiche di visita.",
            },
            {
                h: "4. Base giuridica",
                p: "Il trattamento si basa sul tuo consenso (art. 6.1.a GDPR) per gli account e i contenuti caricati, e sul legittimo interesse (art. 6.1.f GDPR) per la manutenzione e la sicurezza del sito.",
            },
            {
                h: "5. Conservazione",
                p: "I dati degli account vengono conservati finché l'account resta attivo. Puoi richiederne la cancellazione in qualsiasi momento scrivendo a info@abnormalworld.it.",
            },
            {
                h: "6. Condivisione",
                p: "Non vendiamo né cediamo i tuoi dati a terzi. Possono accedere ai dati solo i fornitori tecnici che supportano il funzionamento del sito (hosting, analytics), vincolati da contratto GDPR-compliant.",
            },
            {
                h: "7. I tuoi diritti",
                p: "Hai diritto di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità dei tuoi dati (artt. 15-22 GDPR). Per esercitarli scrivi a info@abnormalworld.it. Puoi inoltre proporre reclamo al Garante Privacy (www.garanteprivacy.it).",
            },
            {
                h: "8. Sicurezza",
                p: "Le password sono memorizzate con algoritmo bcrypt e mai in chiaro. Le connessioni al sito sono cifrate via HTTPS.",
            },
            {
                h: "9. Cookie",
                p: "Per l'uso dei cookie consulta la Cookie Policy dedicata.",
            },
        ],
    },
    en: {
        title: "Privacy Policy",
        eyebrow: "Privacy Notice",
        updated: "Last updated: April 2026",
        sections: [
            { h: "1. Data Controller", p: "The controller of data collected through abnormalworld.it is ABNORMAL WORLD — Monte Argentario (GR), Tuscany, Italy. Contact: info@abnormalworld.it" },
            { h: "2. Data we collect", p: "We only collect data strictly necessary for the site to work: (a) registration data you voluntarily provide (name, email, hashed password); (b) photos and content you upload; (c) technical browsing data (anonymized IP, browser type, pages visited) via technical cookies and — with your consent — analytics cookies." },
            { h: "3. Purposes", p: "We use data to: enable account access, publish the content you upload, improve site operation and — with your consent — analyze anonymized visitor statistics." },
            { h: "4. Legal basis", p: "Processing is based on your consent (art. 6.1.a GDPR) for accounts and uploaded content, and on legitimate interest (art. 6.1.f GDPR) for site maintenance and security." },
            { h: "5. Retention", p: "Account data is kept while the account is active. You can request deletion at any time by emailing info@abnormalworld.it." },
            { h: "6. Sharing", p: "We do not sell or share your data with third parties. Only technical providers supporting site operation (hosting, analytics) may access data under GDPR-compliant contracts." },
            { h: "7. Your rights", p: "You have the right to access, rectify, delete, restrict, object to and port your data (arts. 15-22 GDPR). To exercise them email info@abnormalworld.it. You can also file a complaint with the Italian Data Protection Authority (www.garanteprivacy.it)." },
            { h: "8. Security", p: "Passwords are stored with bcrypt algorithm and never in plain text. Site connections are encrypted via HTTPS." },
            { h: "9. Cookies", p: "For cookie usage please see the dedicated Cookie Policy." },
        ],
    },
};

export default function Privacy() {
    const { lang } = useLang();
    const c = CONTENT[lang] || CONTENT.it;
    return (
        <div data-testid="privacy-page" className="max-w-[820px] mx-auto px-5 md:px-10 py-14 md:py-20 text-zinc-200">
            <SEO title={c.title} description={lang === "en" ? "Privacy policy of abnormalworld.it: data controller, purposes, cookies and your rights." : "Privacy policy di abnormalworld.it: titolare, finalità, cookie e diritti dell'utente."} path="/privacy" />
            <p className="text-xs tracking-[0.3em] uppercase text-abnormal-acid font-bold mb-3">{c.eyebrow}</p>
            <h1 className="font-sans font-bold text-4xl md:text-5xl leading-tight tracking-tight">{c.title}</h1>
            <p className="text-sm text-zinc-500 mt-2">{c.updated}</p>
            <div className="mt-10 space-y-8">
                {c.sections.map((s, i) => (
                    <section key={i}>
                        <h2 className="font-sans font-bold text-xl md:text-2xl text-white">{s.h}</h2>
                        <p className="mt-2 text-base leading-relaxed">{s.p}</p>
                    </section>
                ))}
            </div>
        </div>
    );
}
